import SysRecord from "app/class/record";
import { axiosInterceptor } from "../request-interceptor";
import { generatePassword } from "app/services/global/user-utils";

const isSessionAlive = async () => {
    return axiosInterceptor.get("/auth/session_alive");
}

const postUser = async (record: SysRecord) => {
    let initialPassword = generatePassword();
    let userPayload = {
        sys_user: {
            ...record,
            "password": initialPassword,
            "confirm_password": initialPassword
        }
    }
    return axiosInterceptor.post("/auth", userPayload);
}

const updateUser = async (record: SysRecord) => {
    let userPayload = {
        sys_user: record
    }
    return axiosInterceptor.patch("/auth", userPayload);
}

const updateUserPassword = async (userId: string, record: SysRecord) => {
    return axiosInterceptor.put("/auth/password/" + userId, record);
}

const sessionApi = { isSessionAlive, postUser, updateUser, updateUserPassword };
export { isSessionAlive, postUser, updateUser, updateUserPassword };
export default sessionApi;